import { Box, Button, DataGrid } from "devextreme-react";
import { BaseButton } from "../components/BaseButton/BaseButton";
import { ROUTE_CONTRACTS_PAGE, ROUTE_CREATE_A_NEW_CONTRACT_RECORD, ROUTE_CONTRACT_UPDATE, ROUTE_WELCOME } from "../routes/Routes";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import GetFetch from "../hooks/GetFetch";
import { useState } from "react";
import { LoadingIndicatorCircle } from "../components/Loading";
import { LoadingPanel } from "../components/LoadingPanel";
import { Column, Editing, Item, KeyboardNavigation, Pager, Paging, SearchPanel, Toolbar } from "devextreme-react/data-grid";
import CustomPreparedHeaderCell from "../components/CustomPreparedHeaderCell";
import { useAuth } from "../hooks/useAuth";
import { RowExpander } from "../components/RowExpander/RowExpander";
import { Col } from "devextreme-react/cjs/responsive-box";

const ContractPage = () => {
    const title = ROUTE_CONTRACTS_PAGE.title;
    const {
        user: { Regions }
    } = useAuth();
    const { user } = useAuth();
    const [allowEditing, setAllowEditing] = useState(false);
    const [allowCreate, setAllowCreate] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState();
    const [contracts, setContracts] = useState();
    const [repOfficials, setRepOfficials] = useState([]);
    const navigate = useNavigate();
    const navigateToHomePage = () => navigate(ROUTE_WELCOME.withSlash);
    const endpoint = '/v1/Contract/GetContracts';
    const URL_contractOfficialRep = "/v1/Contract/GetContractPersonnel";
    const unauthorizedCreateRoles = ['missionsupportapprover', 'basicuser',
        'regionaltcmuser', 'hqrevenueuser',
        'accountadministrator', 'fycostuser']
    useEffect(() => {
        document.title = title;
        const permissions = user.role.ModulePermissions?.filter(module => { return (module.Page == "ROUTE_CONTRACTS_PAGE") })
        setAllowEditing(permissions?.filter(module => { return (module.Update) }).length > 0)
        setAllowCreate(permissions?.filter(module => { return (module.Create) }).length > 0 && !unauthorizedCreateRoles.includes(user.role.Name.toLowerCase()))
        fetchContracts();
        fetchRepOfficials();
    }, []);

    const fetchRepOfficials = async () => {
        const data = await GetFetch(URL_contractOfficialRep);
        const { Success, Message, Errors } = data;
        setError(Success === false);
        if (Success) {
            setRepOfficials(Message);
            // console.log(Message);
        }
    }
    const fetchContracts = async () => {
        setLoading(true);
        const data = await GetFetch(endpoint);
        const { Success, Message, Errors } = data;
        setError(Success === false);
        if (Success) {
            setContracts(Message);
            // console.log(Message);
        }
        if (Errors?.length > 0) {
            setErrorMessage(Errors[0].Message)
            console.log(Errors)
        }
        setLoading(false);
    };

    const onBackClick = () => {
        navigateToHomePage();
    };

    const handleContractEdit = (e) => {
        var contractNumber = e.data.Number
        navigate(ROUTE_CONTRACT_UPDATE.withSlash, {
            contractNumber: { contractNumber }
        });
    }
    const renderContractEdit = (e) => {
        var contractNumber = e.data.Number;
        // navigate(ROUTE_CONTRACT_UPDATE.withSlash, {
        //     contractNumber: { contractNumber }});
        return <a href={ROUTE_CONTRACT_UPDATE.withSlash + '?id=' + contractNumber} onClick={e => handleContractEdit(e)} style={{fontWeight: 'bold', color: '#005288'}}>{'Edit: ' + contractNumber}</a>;
    }



    const contractRep = (cellInfo) => {

        if (repOfficials && repOfficials.length > 0) {
            let element = repOfficials.filter(x => x.Id === cellInfo.value);
            if (element.length === 1) { return element[0].OfficerFirstName + ' ' + element[0].OfficerLastName; }
        }

        return cellInfo.value;
    }



    return (
        <>
            <h1>{ROUTE_CONTRACTS_PAGE.title}</h1>

            {allowCreate &&
                <BaseButton
                    id="add_new_contract_button_029"
                    label={"Add a New Contract"}
                    onClick={() => navigate(ROUTE_CREATE_A_NEW_CONTRACT_RECORD.withSlash)}
                    variant={"outlined"}
                />
            }
            {error && <p>{errorMessage.includes("No records") ? errorMessage : "Something went wrong."}</p>}
            {loading && !contracts && <LoadingPanel location={{ of: '#contract-list' }} message="Loading Contracts List..." />}
            {contracts &&
                <div id='contract-list'>
                    <DataGrid
                        columnAutoWidth={true}
                        dataSource={contracts}
                        onCellPrepared={CustomPreparedHeaderCell}
                        showBorders={true}
                        showColumnLines={true}
                        showRowLines={true}
                        rowAlternationEnabled={true}
                        key="ContractId">
                        <KeyboardNavigation enabled={true} />
                        <SearchPanel visible={true} />
                        <Toolbar>
                            <Item
                                name="searchPanel"
                                locateInMenu="auto"
                            />
                            <Item location='after'>
                                <Button text='Home' icon='home' stylingMode='outlined' type='normal' onClick={onBackClick} />
                            </Item>
                        </Toolbar>
                        <Paging defaultPageSize={10} />
                        <Pager
                            showPageSizeSelector={true}
                        />
                        {/*                         <Column
                            type='detailExpand'
                            cellRender={(data) => RowExpander(data, "Number")}
                        /> */}
                        <Column dataField="Number" name="Edit" caption="" width={205} cellRender={(e) => renderContractEdit(e)} />
                        <Column dataField="Number" caption="Contract Number" width={250} />
                        <Column dataField="AwardDate" caption="Award Date" width={120} dataType="date" />
                        <Column dataField="StartDate" caption="Period of Performance Start Date" width={250} dataType="date" />
                        <Column dataField="EndDate" caption="Period of Performance End Date" width={250} dataType="date" />
                        <Column dataField="TaskOrders.length" caption="Task Orders" width={110} dataType="number" />
                        {/*                         <Column dataField="ContractRepId" caption="Contracting Official" width={120}
                            customizeText={contractRep} /> */}
                        {/*                         <MasterDetail
                            enabled={true}
                            render={DetailSection}
                        /> */}
                    </DataGrid>
                </div>
            }
        </>
    )
}

const DetailSection = ({ data }) => {
    return (
        <div>
            <DataGrid
                dataSource={data.TaskOrders}
                showBorders={true}
                columnAutoWidth={true}
                key="TaskOrderId"
            >
                <Column dataField="Number" caption="Task Order Number" />
                <Column dataField="StartDate" caption="Start Date" />
                <Column dataField="EndDate" caption="End Date" />
                <Column dataField="AwardDate" caption="Award Date" />
                <Column dataField="VendorName" caption="Vendor Name" />
                <Column dataField="LineNumber" caption="Line Number" />
                <Column dataField="ProductCodeId" caption="Product Code ID" />
                <Column dataField="ProductDescriptionId" caption="Product Description ID" />
                <Column dataField="RegionId" caption="Region" />
            </DataGrid>
        </div>
    )
}
export default ContractPage;